export default __webpack_public_path__ + "static/wekan_rounded-85d40d18908938c2d703b51d647708a8.gif";